import { ICON_PATH } from '@federa/const/icon-svg-paths';
import { createIcon } from '../createIcon.tsx';

export const HomeIcon = createIcon(
	'HomeIcon',
	<>
		<path d={ICON_PATH.HOUSE_OUTLINE} />
		<polyline points="9 22 9 12 15 12 15 22" />
	</>,
);
